import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, useIntl } from 'react-intl';
import Translation from '../../../../components/stateless/Translation';
import { REQUIRE_FEE_DISPLAY_STATES } from '../../../../../constants/facility';
import SMTooltip from '../SMTooltip';

const propTypes = {
  facilityState: PropTypes.string,
  facilityStates: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  facilityState: '',
  facilityStates: [],
};

const StateFeeDisplay = ({
  facilityState,
  facilityStates,
}) => {
  const { locale, messages } = useIntl();
  const showAdminFee = REQUIRE_FEE_DISPLAY_STATES.includes(facilityState.toLowerCase())
    || facilityStates.some(state => REQUIRE_FEE_DISPLAY_STATES.includes(state.toLowerCase()));

  return (
    <>
      {showAdminFee ? (
        <div className="flex gap-2 md:gap-6 flex-col md:flex-row mb-4 md:items-center">
          <div className="flex gap-2 flex-row items-center">
            <i className="fa fa-fw fa-user-gear" aria-hidden="true" />
            <div>
              <span className="mr-1">
                <Translation
                  id="widgets.summary.feeforadmin"
                  defaultMessage="One-time Admin Fee:"
                />
              </span>
              <strong className="font-bold mr-2">$29</strong>
              <SMTooltip
                body={(
                  <IntlProvider locale={locale} messages={messages}>
                    <Translation
                      id="widgets.summary.feeforadmin.tooltip"
                      defaultMessage="The non-refundable admin fee covers startup costs for your rental."
                    />
                  </IntlProvider>
                )}
              />
            </div>
          </div>
          <div className="flex gap-2 flex-row items-center">
            <i className="fa fa-fw fa-lock" aria-hidden="true" />
            <div>
              <span className="mr-1">
                <Translation
                  id="widgets.summary.feeforlock"
                  defaultMessage="One-time Lock Fee:"
                />
              </span>
              <strong className="font-bold mr-2">$16.99</strong>
              <SMTooltip
                body={(
                  <IntlProvider locale={locale} messages={messages}>
                    <Translation
                      id="widgets.summary.feeforlock.tooltip"
                      defaultMessage="The fee covers a new lock. Bring your own and return ours unopened for a refund."
                    />
                  </IntlProvider>
                )}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

StateFeeDisplay.propTypes = propTypes;
StateFeeDisplay.defaultProps = defaultProps;

export default StateFeeDisplay;
